// Converted from application/views/bio_v.php. Edit this component directly.
export default function BioPage() {
  return <><h1>{"Biography"}</h1>
<div class={"row"}>
<div class={"column"}>
<dl>
<dt class={"show"}><span>{"1942"}</span></dt><dd><span>{"Born Dublin, Ireland."}<br />{"Showed a rare talent for figurative art and portraiture from an early age."}</span></dd>
<dt class={"show"}><span>{"1960/80"}</span></dt><dd><span>{"Combined his studies at the National College of Art in Ireland while creating a successful hospitality business."}</span></dd>
<dt class={"show"}><span>{"1990/2000"}</span></dt><dd><span>{"Reignited his deep commitment to art, retiring from business to study and practice the techniques of the Renaissance Masters in Florence."}</span></dd>
<dt class={"show"}><span>{"2000/2024"}</span></dt><dd><span>{"Recognising that his true gift was sculpture, he established his studio in Florence, where he continues to display his remarkable originality and versatility."}<br />{"\n            In 2021 he was awarded the Fra Angelico-Giotto Award for his contribution to Art and Culture in Tuscany."}<br />
<br />
<blockquote style={{"margin":"2rem auto 4rem auto"}}>
<p>{"At the origin of every one of his pieces, even before they are brought into being, is an inexhaustible need for authenticity."}</p>
</blockquote><footer>{"—Giovanni Faccenda"}<br />{"\n            “Di Cuore”, Palazzo Medici Riccardi, Florence, 2013."}</footer>
</span></dd>
</dl>
</div>
<div class={"column"}>
<img src={"/assets/images/home/paddy-at-work.jpg"} alt={"Paddy Campbell at work"} />
</div>
</div>
</>;
}
